import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueRx from 'vue-rx'


// Third party
import PortalVue from 'portal-vue'
import Vuetify from 'vuetify'
import Notifications from 'vue-notification'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import velocity from 'velocity-animate'
import { time, date } from '@/utils/filters/time'

// CSS
import './assets/styles/main.css'
import 'nprogress/nprogress.css'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

import { authService } from '@/services/AuthService'

// Mixins
import global from '@/utils/mixins/global'

const token = authService.getToken()
if (token) {
  authService.setHeader(token)
}

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

Sentry.init({
  Vue,
  dsn: 'https://e48c3e1c065b46e4acbfc22f0d44095d@o463437.ingest.sentry.io/5472853',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0
})

const requireComponent = require.context(
  './components/base',
  true,
  /Base[A-Z]\w+\.(vue|js)$/
)


requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
  )
  console.log(fileName)
  Vue.component(componentName, componentConfig.default || componentConfig)
})

Vue.use(Vuetify)
Vue.use(PortalVue)
Vue.use(Notifications, { velocity })

//netPrice,totalExcise,totalNds,totalNet,totalPrice,vatPerTons
import {
  totalPrice,
  totalNds,
  excise,
  nds,
  priceClearPrice,
  priceClearNdsPrice,
  priceClearPrices,
  priceClearNdsPrices, appendixTotalCalculate
} from '@/utils/filters/oil.js'
import { density, liter, price, ton, totalPrice2 } from '@/utils/filters/oil'

Vue.filter('totalPrice', totalPrice)
Vue.filter('totalPrice2', totalPrice2)
Vue.filter('totalNds', totalNds)
Vue.filter('excise', excise)
Vue.filter('nds', nds)
Vue.filter('appendixTotalCalculate', appendixTotalCalculate)
Vue.filter('priceClearPrice', priceClearPrice)
Vue.filter('priceClearNdsPrice', priceClearNdsPrice)
Vue.filter('priceClearPrices', priceClearPrices)
Vue.filter('priceClearNdsPrices', priceClearNdsPrices)


Vue.filter('time', time)
Vue.filter('date', date)
Vue.filter('price', price)
Vue.filter('liter', liter)
Vue.filter('ton', ton)
Vue.filter('density', density)

Vue.mixin(global)
Vue.use(VueRx)

Vue.config.productionTip = false

const theme = localStorage.getItem('theme')

new Vue({
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdi'
    },
    theme: {
      dark: theme === 'dark'
    }
  }),
  router,
  store,
  render: h => h(App)
}).$mount('#app')